import { useQuery } from '@apollo/client'
import { CircularProgress, Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  getClientId,
  getClientType,
  getClientTypeUrl,
  isCorporate,
  isCorporateAdmin,
  isCorporateCeo,
  isCorporateIndividual,
  isCorporateLeader,
  isCorporatePOC,
  isEBPolicy,
  isHealthInsurance,
  isMotorInsurance,
  isRetailIndividual,
} from 'src/utils/commonMethods'
import keycloak from 'src/utils/commonMethods/keycloak'
import { COLORS } from 'src/utils/Themes/colors'
import { Button } from '@mui/material'
import endorsementPic from 'src/assets/PolicyTile_Images/Group1322.svg'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import MotorFullDetails from 'src/components/Individual/common/MotorFullDetails'
import AllPolicies from 'src/components/Individual/common/AllPolicies'
import PolicyCoverages from 'src/components/Individual/common/PolicyCoverages'
import AllDocuments from 'src/components/Individual/common/AllDocuments'
import KeyNotes from 'src/components/Individual/common/KeyNotes'
import PolicyDetailsCard from 'src/components/Individual/common/PolicyDetailsCard'
import Endorsements from 'src/components/Individual/common/Endorsements'
import Claims from 'src/components/Individual/common/Claims'
import FAQ from 'src/components/Individual/common/FAQ'
import {
  invokeAllTypesSXP,
  KEYNOTES,
  MEMBER_PAGE_DETAILS,
} from 'src/services/individualService'
import CallToAction from 'src/components/Individual/common/CallToAction'
import { COVERAGE_HEADING, POLICY_TYPE } from 'src/utils/constants/common'
import InsuranceDetailsTour from 'src/ProductTour/InsuranceDetailsTour'
import { GROUP_HEALTH_LIST } from 'src/utils/constants/RiskReports'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useLocation } from 'react-router-dom'
import MemberDetails from 'src/components/common/MemberDetails'
import { VIEWEMPLOYEE } from 'src/utils/constants/Individual'
import CommonTable from 'src/components/common/CommonTable'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import { PAYMENT_OPTIONS } from 'src/utils/constants/Renewals'
import { VIEW_INSTALLMENT_COLUMNS } from 'src/utils/constants/InsuranceDetails'

const InsuranceDetails = ({
  closeFunction,
  clientId,
  clientType,
  isCEO,
  activePolicy,
  activePolicyType,
  path,
  policyType,
  isCompanyPolicy = false,
  isEmployeeView = false,
  isCeoView,
}) => {
  const classes = useStyles()
  const userInfo = useSelector((state) => state?.userInfo)
  const activeInsuranceDetailsTour = useSelector(
    (state) => state?.tourReducer?.insuranceDetailsTour
  )
  const [tourCompleted, setTourCompleted] = useState(false)
  const [showInstallments, setShowInstallments] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (tourCompleted) {
      closeFunction()
    }
  }, [tourCompleted, closeFunction])

  const {
    loading: annexureDetailsLoading,
    error: annexureDetailsError,
    data: annexureDetailsData,
  } = useQuery(MEMBER_PAGE_DETAILS(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      policyID: activePolicy?.id,
      clientId: getClientId(clientId, userInfo),
      viewForCEO: isCEO,
      search: '',
      page: 0,
      size: 10,
    },
    // skip: isPersonalPolicy(activePolicyType),
  })

  const {
    loading: keyNotesLoading,
    error: keyNotesError,
    data: keyNotesData,
  } = useQuery(KEYNOTES(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      activePolicyInsuranceType: activePolicy?.insuranceType,
    },
  })

  if (annexureDetailsLoading || keyNotesLoading)
    return (
      <div className='loadingContainer'>
        <CircularProgress />
      </div>
    )
  if (annexureDetailsError || keyNotesError) {
    return (
      <>
        <GraphQlErrors error={annexureDetailsError || keyNotesError} />
      </>
    )
  }

  const getEndorsementClientId = () => {
    if (activePolicyType === POLICY_TYPE?.PERSONAL) {
      return userInfo?.userInfo?.userData?.mobileNumber
    }
    return getClientId(clientId, userInfo)
  }

  const isViewEmployee = () => {
    return location?.pathname?.includes(VIEWEMPLOYEE)
  }

  const isOnCompanyPage = location?.pathname?.includes('company')

  const invokeEndorsementSxp = () => {
    const sxpBody = {
      state: {
        clientId: getEndorsementClientId(),
        clientType: getClientType(clientType, userInfo),
        documentType: activePolicy?.insuranceType,
        createdBy: userInfo?.userName,
        updatedBy: userInfo?.userName,
        requestTypeId: activePolicy?.id,
        policy: activePolicy,
        memberDetails: annexureDetailsData?.getMemberPage,
        roles: userInfo?.userInfo?.userData?.roles,
        sysAnnexureDocumentURL: activePolicy?.sysAnnexureDocumentURL,
        sysAnnexureDocument: activePolicy?.sysAnnexureDocument,
        email: userInfo?.userInfo?.userData?.emailId,
        endorsementRaisedFor: getClientId(clientId, userInfo),
        policyType: policyType,
        token: keycloak.token,
        clientTypeUrl: getClientTypeUrl(getClientType(clientType, userInfo)),
        url: path,
        isCompanyPolicy: isCompanyPolicy,
      },
      userId: userInfo?.userName,
    }
    invokeAllTypesSXP(sxpBody, userInfo?.userName, 'endorsement')
  }

  const getMemberDetailsData = () => {
    return !activePolicy?.isCompanyPolicy
      ? activePolicy?.policyHolder?.policyMembers
      : annexureDetailsData?.getMemberPage?.content
  }

  const isIncludedInGroupList = () => {
    return GROUP_HEALTH_LIST?.includes(activePolicy?.insuranceType)
  }

  const showCompanyCoveredText = () => {
    return (
      !location?.pathname?.includes('company') && activePolicy?.isCompanyPolicy
    )
  }

  const showBothCoverageTypes = () => {
    return (
      activePolicy?.isCompanyPolicy &&
      (isCorporatePOC(userInfo?.userInfo?.userData?.roles) ||
        isCorporateAdmin(userInfo?.userInfo?.userData?.roles) ||
        isCorporateCeo(userInfo?.userInfo?.userData?.roles) ||
        isCorporateLeader(userInfo?.userInfo?.userData?.roles) ||
        isCorporate(userInfo?.userInfo?.userData?.roles)) &&
      !isEmployeeView &&
      !isCeoView &&
      isEBPolicy(activePolicy?.insuranceType)
    )
  }

  const showIndividualCoverageTypes = () => {
    return (
      activePolicy?.isCompanyPolicy &&
      (isCorporateIndividual(userInfo?.userInfo?.userData?.roles) ||
        isRetailIndividual(userInfo?.userInfo?.userData?.roles)) &&
      (!(
        isCorporatePOC(userInfo?.userInfo?.userData?.roles) ||
        isCorporateAdmin(userInfo?.userInfo?.userData?.roles) ||
        isCorporateCeo(userInfo?.userInfo?.userData?.roles) ||
        isCorporateLeader(userInfo?.userInfo?.userData?.roles) ||
        isCorporate(userInfo?.userInfo?.userData?.roles)
      ) ||
        isEmployeeView ||
        isCeoView)
    )
  }

  const showCoverageTypes = () => {
    return (
      (!activePolicy?.isCompanyPolicy &&
        (isCorporateIndividual(userInfo?.userInfo?.userData?.roles) ||
          isRetailIndividual(userInfo?.userInfo?.userData?.roles))) ||
      !isEBPolicy(activePolicy?.insuranceType)
    )
  }

  const coverageTypes = activePolicy?.coverageTypes
  const coverageTypes_array =
    coverageTypes !== null ? coverageTypes?.split(',') : null

  const individualCoverageTypes = activePolicy?.individualCoverageTypes
  const individualCoverageTypes_array =
    individualCoverageTypes !== null
      ? individualCoverageTypes?.split(',')
      : null

  return (
    <>
      {activeInsuranceDetailsTour && (
        <InsuranceDetailsTour
          setTourCompleted={setTourCompleted}
          userId={userInfo?.userInfo?.userData?.userId}
          token={keycloak?.token}
        />
      )}

      <div className={classes.root}>
        <div className={classes.goBackContainer} onClick={closeFunction}>
          <img src={arrow} alt='arrow' />
          <span className={classes.gotoBackButton}>Back To Policies</span>
        </div>

        <div id='insuranceDetail'>
          <Grid
            container
            spacing={2}
            alignItems='stretch'
            className={classes.contentDetails}
          >
            <Grid
              id='insuranceDetail'
              item
              xs={12}
              sm={6}
              md={3}
              className={classes.container}
            >
              {showCompanyCoveredText() ? (
                <div
                  id='congratulationsDetail'
                  className={`${classes.cardRoot} p-0`}
                >
                  <div className={classes.cardRootText}>
                    Congratulations your company,&nbsp;
                    <span className={classes.companyText}>
                      {activePolicy?.companyName}
                    </span>
                    &nbsp;covered you for the below policy.
                  </div>
                </div>
              ) : null}
              {isMotorInsurance(activePolicy?.insuranceType) ? (
                <div id='insuranceDetail' className={`${classes.cardRoot} p-0`}>
                  <MotorFullDetails activePolicy={activePolicy} />
                </div>
              ) : (
                <div id='allPolicies' className={`${classes.cardRoot} p-0`}>
                  <AllPolicies activePolicy={activePolicy} />
                </div>
              )}
              {(isOnCompanyPage || !activePolicy?.isCompanyPolicy) &&
                activePolicy?.paymentType === PAYMENT_OPTIONS?.INSTALLMENTS && (
                  <Button
                    size='small'
                    endIcon={
                      showInstallments ? <ArrowRightIcon /> : <ArrowLeftIcon />
                    }
                    className={classes.viewInstallmentsBtn}
                    onClick={() => setShowInstallments(!showInstallments)}
                  >
                    View Installments
                  </Button>
                )}

              {showCoverageTypes() && (
                <div id='policyCoverages' className={classes.cardRoot}>
                  <PolicyCoverages
                    coverageTypes={coverageTypes}
                    coverageTypes_array={coverageTypes_array}
                    policyCoverageHeading={COVERAGE_HEADING?.policyCoverages}
                  />
                </div>
              )}
              {showIndividualCoverageTypes() && (
                <div id='policyCoverages' className={classes.cardRoot}>
                  <PolicyCoverages
                    coverageTypes={individualCoverageTypes}
                    coverageTypes_array={individualCoverageTypes_array}
                    policyCoverageHeading={
                      COVERAGE_HEADING?.individualCoverages
                    }
                  />
                </div>
              )}
              {showBothCoverageTypes() && (
                <>
                  <div id='policyCoverages' className={classes.cardRoot}>
                    <PolicyCoverages
                      coverageTypes={coverageTypes}
                      coverageTypes_array={coverageTypes_array}
                      policyCoverageHeading={COVERAGE_HEADING?.policyCoverages}
                    />
                  </div>

                  <div id='policyCoverages' className={classes.cardRoot}>
                    <PolicyCoverages
                      coverageTypes={individualCoverageTypes}
                      coverageTypes_array={individualCoverageTypes_array}
                      policyCoverageHeading={
                        COVERAGE_HEADING?.individualCoverages
                      }
                    />
                  </div>
                </>
              )}

              <div id='Hospital_Network_List'>
                {isHealthInsurance(activePolicy?.insuranceType) && (
                  <div className={classes.cardRoot}>
                    <CallToAction tpaId={activePolicy?.otherInformation?.tpa} />
                  </div>
                )}
              </div>

              {/* ToDo: Need to update the condition to show or download the Policy Document (Task: 2738) */}
              {(isCEO ||
                isHealthInsurance(activePolicy?.insuranceType) ||
                !isIncludedInGroupList()) && (
                <div id='allDocuments' className={classes.cardRoot}>
                  <AllDocuments
                    data={activePolicy}
                    healthCards={getMemberDetailsData()}
                    activePolicyInsuranceType={activePolicy?.insuranceType}
                    isCEO={isCEO}
                  />
                </div>
              )}

              {!(
                isMotorInsurance() ||
                isHealthInsurance(activePolicy?.insuranceType)
              ) && (
                <div id='keyNotes' className={classes.cardRoot}>
                  <KeyNotes
                    keyNotesData={keyNotesData?.getKeyPointsFAQData?.keyPoints}
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12} sm={6} md={9} className={classes.container}>
              <div id='policyDetailsCard' className={classes.cardRoot}>
                <PolicyDetailsCard activePolicy={activePolicy} />
              </div>
              {showInstallments && (
                <CommonTable
                  columns={VIEW_INSTALLMENT_COLUMNS}
                  data={activePolicy?.installmentDetails}
                />
              )}
              {isHealthInsurance(activePolicy?.insuranceType) && (
                <div className={classes.memberDetailsContainer}>
                  <div
                    id='viewPolicyMemberDetails'
                    className={`${classes.cardRoot} flex-1`}
                  >
                    <MemberDetails
                      memberDetailsList={getMemberDetailsData()}
                      isCEO={isCEO}
                      policyId={activePolicy?.id}
                      clientId={getClientId(clientId, userInfo)}
                      isCompanyPolicy={activePolicy?.isCompanyPolicy}
                      clientIdData={getClientId(clientId, userInfo)}
                    />
                  </div>

                  <div id='keyNotes' className={`${classes.cardRoot} flex-1`}>
                    <KeyNotes
                      keyNotesData={
                        keyNotesData?.getKeyPointsFAQData?.keyPoints
                      }
                    />
                  </div>
                </div>
              )}

              <div className={classes.sectionHeadingContainer}>
                <span className={classes.sectionHeading}>Endorsements</span>{' '}
                {((!isCorporateCeo(userInfo?.userInfo?.userData?.roles) &&
                  !isViewEmployee()) ||
                  (isCorporateCeo(userInfo?.userInfo?.userData?.roles) &&
                    !isOnCompanyPage)) && (
                  <span>
                    <Button
                      id='newRequestButton'
                      className={classes.newRequestButton}
                      onClick={invokeEndorsementSxp}
                    >
                      New Request
                      <img
                        src={endorsementPic}
                        className={classes.endorsementPic}
                      />
                    </Button>
                  </span>
                )}
              </div>

              <div id='endorsements' className={classes.cardRoot}>
                <Endorsements
                  policyId={activePolicy?.id}
                  clientId={getClientId(clientId, userInfo)}
                  isCEO={isCEO}
                />
              </div>

              <div className={classes.sectionHeadingContainer}>
                <p className={classes.sectionHeading}>Claims</p>
              </div>

              <div id='claims' className={classes.cardRoot}>
                <Claims policyId={activePolicy?.id} />
              </div>

              <div className={classes.sectionHeadingContainer}>
                <p className={classes.sectionHeading}>FAQ&apos;s</p>
              </div>

              <div id='FAQ' className={classes.cardRoot}>
                <FAQ data={keyNotesData?.getKeyPointsFAQData?.faq} />
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  )
}

export default InsuranceDetails

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    background: COLORS.WHITE,
    position: 'relative',
    height: '100%',
  },
  contentDetails: {
    width: '100%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  memberDetailsContainer: {
    display: 'flex',
    gap: '5px',
  },
  cardRoot: {
    border: `1px solid ${COLORS.BLACK01}`,
    borderRadius: '10px',
    overflow: 'hidden',
  },
  goBackContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    marginBottom: '10px',
  },
  gotoBackButton: {
    fontSize: '12px',
    border: '1px',
    cursor: 'pointer',
    color: '#4F4F4F',
  },
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.WHITE,
    color: COLORS.SKYBLUE01,
    margin: '-4px 0 10px 9px',
    height: '31px',
    padding: '0px 10px',
    borderRadius: '6px',
    border: `1px solid ${COLORS.SKYBLUE01}`,
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
  },
  newRequestButton: {
    textTransform: 'unset !important',
    fontSize: '11px !important',
    fontWeight: '600 !important',
    background: `${COLORS.WHITE} !important`,
    color: `${COLORS.SKYBLUE01} !important`,
    margin: 'unset !important',
    height: '31px !important',
    padding: '0px 10px !important',
    borderRadius: '6px !important',
    border: `1px solid ${COLORS.SKYBLUE01} !important`,
    '&:hover': {
      backgroundColor: `${COLORS.WHITE} !important`,
    },
  },
  sectionHeading: {
    margin: '0px 0px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
    textAlign: 'initial',
    marginLeft: '15px',
  },
  sectionHeadingContainer: {
    display: 'flex',
    width: '100%',
    paddingTop: '5px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  endorsementPic: {
    width: '14px',
    paddingLeft: '5px',
  },
  cardRootText: {
    textAlign: 'center',
    background: 'linear-gradient(45deg, #eeeeee 0%,#ffffff 100%)',
    padding: '30px 10px',
    wordBreak: 'break-word',
  },
  companyText: {
    color: '#B92250',
  },
  viewInstallmentsBtn: {
    color: '#B92250 !important',
    border: '1px solid #B92250 !important',
    borderRadius: '10px !important',
  },
})
